import { combineReducers } from 'redux';

import emailQuote from './emailQuoteReducer';
import quoteDetails from './quoteDetailsReducer';
import quoteLoading from './quoteLoadingReducer';
import firstCar from './firstCarReducer';
import secondCar from './secondCarReducer';

export default combineReducers({
  emailQuote,
  quoteDetails,
  quoteLoading,
  firstCar,
  secondCar,
});
